import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';

const API_URL = '/vendors';

const sanitizeVendorData = (vendorData) => {
  const data = { ...vendorData }; // Create a shallow copy to avoid mutating original
  const authStore = useAuthStore();
  data.company_id = data.company_id || authStore.currentUser?.company_id;

  // Ensure numeric fields are numbers
  // if (data.phone) data.phone = Number(data.phone);

  // Normalise enums to backend's exact casing
  if (data.service_offered) data.service_offered = data.service_offered.toLowerCase();   // apartment | house �

  return data;
};

export default {
  async getVendors() {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    
    // Build URL with company filter if user has a company_id
    let url = '/vendors';
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    
    return (await apiClient.get(url)).data;
  },
  async getVendor(id)           { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async createVendor(data)      { const r = await apiClient.post(API_URL, sanitizeVendorData(data)); return r.data; },
  async updateVendor(id, data)  { const r = await apiClient.put(`${API_URL}/${id}`, sanitizeVendorData(data)); return r.data; },
  async deleteVendor(id)        { return apiClient.delete(`${API_URL}/${id}`); }
};
